import React, { Component } from 'react';
import styled from 'styled-components';
import * as util from '../../utils/util';
import Product from '../../components/product/Product';
import regiment from '../../data/regiment.json';
import ProductNotFound from '../../components/product/ProductNotFound';
import Slider from 'react-slick';
import Countdown from 'react-countdown-now';
import { EVENTS } from 'react-joyride';
import { RESPONSE_STATUS } from '../../utils/constants';
import Responsive from 'react-responsive';
import Modal from 'react-responsive-modal';

import './RecommendationsAdditionalCategories.css';
import './RecommendationsBundle.css';

import Api from '../../utils/api';

const Tutorial = !!global.window && require('react-joyride').default;
let counter = 0;

//USED FOR SORTING CATEGORIES
const indexMapProductsLabeled = {"cleanser":1,"exfoliator":2,"serum":3,"toner":4,"moisturizer":5,"spf":6,"eye cream":7,"mask":8,"make-up remover":11,"treatment":12,"supplement":15};

class RecommendationsSeparateView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            price: 0,
            defaultPurchaseStarted: false,
            defaultPurchaseComplete: false,
            defaultPurchaseStartTime: null,
            productsCart: [],
            productsCartIds: [],
            runTutorial: false,
            productsForPrice: [],
            openAdditionalCategories: false,
            additionalRecommendedProducts: [],
            openCancelModal: false
        }

        this.productsArr = [];

        this.syncProducts = this.syncProducts.bind(this);
        this.handleOptOut = this.handleOptOut.bind(this);
        this.handleOpenAdditionalCategories = this.handleOpenAdditionalCategories.bind(this);
        this.openCancelModal = this.openCancelModal.bind(this);
        this.saveCartForLater = this.saveCartForLater.bind(this);
        this.toggleStickyTimer = this.toggleStickyTimer.bind(this);
    }

    componentWillMount() {
        this.getAdditionalRecommendations();
        this.checkIfCardIsOnStripe();
        // window.addEventListener('scroll', this.toggleStickyTimer, false);
    }

    componentDidMount() {
        // this.getCart();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productsArr !== this.props.productsArr) {
            this.setState({ productsCartIds: this.props.productsArr.map(product => { return product.id }), productsCart: this.props.productsArr });
        }
        
    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.toggleStickyTimer, false);
    }

    /*** STICKY TIMER ***/

    toggleStickyTimer() {
        if (this.state.defaultPurchaseStarted) {
            let timer = document.querySelector(".upper-section-wrapper");
            if (window.innerWidth >= 901) {
                if (window.pageYOffset >= 475) {
                    timer.classList.add('sticky-timer');

                } else {
                    timer.classList.remove('sticky-timer');
                }
            } else {
                if (window.pageYOffset >= 424.6) {
                    timer.classList.add('sticky-timer');

                } else {
                    timer.classList.remove('sticky-timer');
                }
            }
        }

    }

    /*** END STICKY TIMER ***/

   

    

    renderAdditionalRecommendations() {
        let CategoryHolder = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin: 15px 0;
        position: relative
        `;

        let CategoryTitle = styled.div`
        height: 41px;
        line-height: 41px;
        background-color: rgba(252, 219, 207, 0.2);
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-align: left;
        color: #272d67;
        padding: 0 5px;
        @media screen and (max-width: 414px) {
            font-size: 16px;
        }
        `;

        let CategorySmallTitle = styled.div`
        height: 41px;
        line-height: 41px;
        background-color: rgba(252, 219, 207, 0.2);
        font-family: Montserrat;
        font-size: 20px;
        font-weight: normal;
        font-style: italic;
        letter-spacing: 0.6px;
        text-align: left;
        color: #272d67;
        padding: 0 5px 0 0;
        @media screen and (max-width: 414px) {
            font-size: 16px;
        }
        `;

        let InformationButton = styled.div`
        font-size: 21px;
        color: #ffad94;
        margin-left: 20px;
        cursor: default;
        font-family: "Open Sans", Helevetica, Arial, sans-serif
        line-height: 15px;

        .info-popup {
            max-width: 414px;
            padding: 2.5% 3%;
            left: 0;
            z-index: 2;
            white-space: pre-line;
            visibility: hidden;
            background: #fff;
            position: absolute;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

            p {
                font-size: 13px;
                color: #323232;

            }

            span {
                font-family: Montserrat, Helevetica, Arial, sans-serif;
                font-size: 14px;
                color: #262e66;
                font-weight: 600;
            }
        }

        &:hover .info-popup {
            visibility: visible;
        }
        `;

        const sliderSettings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            className: 'ha-slider-recommendations',
            responsive: [
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    className: 'ha-slider-recommendations'
                  }
                },
                {
                  breakpoint: 552,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    className: 'ha-slider-recommendations'
                  }
                }
              ]
        };

        //ORDER OF CATEGORIES
        const indexMapProductsLabeled = {"cleanser":1,"exfoliator":2,"serum":3,"toner":4,"moisturizer":5,"spf":6,"eye cream":7,"mask":8,"make-up remover":11,"treatment":12,"supplement":15};

        let productViews = [];
        const recommendedProducts = this.state.additionalRecommendedProducts ? this.state.additionalRecommendedProducts : [];
        const numOfProducts = this.state.additionalRecommendedProducts ? recommendedProducts.length : 0;
        let tempIndex = -1;

        recommendedProducts.sort((a, b) => {
            return indexMapProductsLabeled[a.type.toLowerCase()] - indexMapProductsLabeled[b.type.toLowerCase()];
        });

        recommendedProducts.forEach((product, index, arr) => {

            let productType = util.capitalize(product.type);
            let recommendedProductsCopy = recommendedProducts.filter((product,index,arr) => {
                    return util.capitalize(arr[index].type) === productType;
                });

            if (((index !== numOfProducts - 1) && (productType.toLowerCase() !== recommendedProducts[index+1].type.toLowerCase())) ||
                (index === numOfProducts - 1)
                ) {

                let productSliderContent = recommendedProductsCopy.map((product, index, arr) => {
                    return(
                        <div>
                            <Product
                                productCart={ this.state.productsCart }
                                isInProductCart={ this.state.productsCartIds.indexOf(product.id) > -1 }
                                product={product} index={ index } key={`product-${tempIndex}`}
                                defaultPurchaseOptIn={ this.state.defaultPurchaseStarted }
                                syncProducts={this.syncProducts}
                                selectProduct={ this.props.selectProduct }
                                selectReviewProduct={this.props.selectReviewProduct}
                                getProductsForCalcPrice={ this.getProductsForCalcPrice.bind(this) }
                                isFirstTime={ false }
                                isAdditionalRec={ true }
                                saveCartForLater={ this.saveCartForLater }
                            />
                        </div>
                    );
                });
                productViews.push(

                    <CategoryHolder className="category-name">
                        <CategoryTitle>{ productType }</CategoryTitle>
                        <CategorySmallTitle>for you</CategorySmallTitle>
                        <InformationButton>
                            &#9432;
                            <div className="info-popup">
                                <span>Why do you need this?</span>
                                <p>{
                                    regiment[productType.toLowerCase()]["whyNeed"] ? regiment[productType.toLowerCase()]["whyNeed"] : "No description available"
                                }</p>
                                <span>How to use it?</span>
                                <p>{
                                    regiment[productType.toLowerCase()]["howToUse"] ? regiment[productType.toLowerCase()]["howToUse"] : "No instructions available"
                                }</p>
                            </div>
                        </InformationButton>
                    </CategoryHolder>
                );
                productViews.push(
                    <Slider { ...sliderSettings } >
                        { productSliderContent }
                    </Slider>
                );
            }
        });

        return productViews;
    }

    /*** END ADDITONAL RECOMMENDATIONS ***/

    /*** DEFAULT PURCHASE API CALLS ***/
    checkIfCardIsOnStripe() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/stripe-customers/status?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                this.checkDefaultPurchaseStatus();
            } else {
                return;
            }
        })
        .catch(err => {
            alert('There was a problem checking for eligibility: ' + err);
        });
    }

    //Start Default Purchase Timer
    startTimerOptIn() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/default-purchases/start?user-id=' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => {
            if (response.status === RESPONSE_STATUS.OK) {
                fetch('/api/default-purchases?user-id=' + userId, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth-token': Api.auth_tokenManager()
                    }
                })
                .then(response => response.json())
                .then(responseJson => {
                    this.setState({
                        defaultPurchaseStartTime: responseJson.createdDate,
                        defaultPurchaseStarted: true,
                        runTutorial: true
                    }, () => {
                        this.props.defaultPurchaseStatus("started");
                        const url = 'https://hooks.zapier.com/hooks/catch/2569749/0z8ws2/';
                        fetch(url, {
                            method: 'POST',
                            body: JSON.stringify({
                                "First Name": this.props.firstName,
                                "Last Name": this.props.lastName,
                                "Phone": this.props.userPhone,
                                "Email": this.props.userEmail
                            })
                        })
                        .catch(function(err) {
                            alert("There was a sending your status. Please try again.");
                        });
                    });
                })
                .catch(err => {
                    alert('There was a problem starting the  timer: ' + err);
                });
            }
        })
        .catch(err => {
            alert('There was a problem starting the default purchase process: ' + err);
        });

    }

    handleOptOut() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/default-purchases/opt-out?user-id=' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                this.setState({ defaultPurchaseStarted: false, defaultPurchaseComplete: false, openCancelModal: false }, () => {
                    this.props.defaultPurchaseStatus("opt-out");
                    const url = 'https://hooks.zapier.com/hooks/catch/2569749/0yrokb/';
                    /* const url = 'https://hooks.zapier.com/hooks/catch/2569749/oo5yzaj/'; */
                    const date = new Date();
                    const phone = "+1 " + this.formatPhoneNumber(this.props.userPhone);
                    // const phone = this.props.userPhone;
                    fetch(url, {
                        method: 'POST',
                        body: JSON.stringify({
                            "fields": {
                                "First Name": this.props.firstName,
                                "Last Name": this.props.lastName,
                                "Phone": phone,
                                "Timestamp": util.convertToStandardTime(date.getTime() / 1000),
                                "Email": this.props.userEmail
                            }
                        })
                    })
                    .catch(function(err) {
                        alert("There was a problem opting out. Please try again.");
                    });
                });
            } else {
                throw new Error("Server response error.")
            }
        })
        .catch(err => {
            alert('There was a problem opting out of your purchase: ' + err);
        });

    }

    formatPhoneNumber(phoneNumberString) {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }


    /*** END DEFAULT PURCHASE ***/

    /*** TUTORIAL ***/
    hideTutorial = () => {
        this.setState({ runTutorial: false });
    }
    /*** END TUTORIAL ***/

    syncProducts(product) {
        let arrProd = this.productsArr;
        let ind = arrProd.indexOf(product);

        if (ind !== -1) {
            arrProd.splice(ind, 1);
        } else {
            arrProd.push(product);
            counter++;
        }

        this.productsArr = arrProd;

        this.props.updateProducts(this.productsArr);
        if (this.state.runTutorial) {
            if (!(this.props.productTypes[0] === 13 || this.props.productTypes[0] === 14)) {
                if (counter === this.props.productTypes.length) this.saveCartForLater();
                else return;
            } else {
                if (this.props.productTypes[0] === 13) {
                    if (counter === 3) this.saveCartForLater();
                    else return;
                } else if (this.props.productTypes[0] === 14) {
                    if (counter === 5) this.saveCartForLater();
                    else return;
                } else {
                    return;
                }
            }
        }
    }

    calculatePrice() {
        let price = 0;
        this.state.productsForPrice.forEach(product => {
            price += parseFloat(product.price);
        });
        this.setState({ price: price.toFixed(2) }, this.props.updatePrice(price.toString()));
    }

    tutorialCallback = (data) => {
        const { action, index, type } = data;
        if (type === EVENTS.TOUR_END || (type === EVENTS.STEP_AFTER && index === 4)) return;
    }

    getProductsForCalcPrice(product) {
        let productsForPrice = this.state.productsForPrice;
        let ind = productsForPrice.indexOf(product);
        if (ind > -1) {
            productsForPrice.splice(ind, 1);
        } else {
            productsForPrice.push(product);
        }

        this.setState({ productsForPrice: productsForPrice }, this.calculatePrice);
    }

    renderProductCategories() {
        const indexMapProductsRef = {1:"Cleanser",2:"Toner",3:"Moisturizer",4:"SPF",5:"Serum",6:"Eye Cream",7:"Exfoliator",8:"Mask",11:"Make-Up Remover",12:"Treatment",13:"3-Step Regimen",14:"5-Step Regimen", 15:"Supplement"};
        const productTypes = this.props.productTypes.sort();
        let outputStr = '';

        productTypes.forEach((id, index) => {
            let category;
            if (index !== productTypes.length - 1) category = indexMapProductsRef[id] + ", ";
            else category = indexMapProductsRef[id];
            outputStr += category;
        });

        return outputStr;
    }

    renderCountdownTimer() {
        let dateStarted = new Date(this.state.defaultPurchaseStartTime);
        dateStarted.setDate(dateStarted.getDate() + 3);

        const renderer = ({ days, hours, minutes, seconds, completed }) => {
          if (completed) {
            // Render a complete state
            // this.props.showThankYouMessage();
            return <span>0d 0h 0m 0s</span>;
          } else {
            // Render a countdown
            return  <span>{days}d {hours}h {minutes}m {seconds}s</span>;
          }
        };

        return(
            this.state.defaultPurchaseStartTime && this.state.defaultPurchaseStartTime !== '' ? <div><Countdown date={ dateStarted } /*{ this.props.timer }*/ renderer={renderer} /></div> : null
        );
    }

    handleOpenAdditionalCategories() {
        this.setState({ openAdditionalCategories: !this.state.openAdditionalCategories });
    }

    /*** CANCEL MODAL ***/
    openCancelModal() {
        this.setState({
            openCancelModal: true
        });
    }

    closeCancelModal() {
        this.setState({
            openCancelModal: false
        });
    }
    /*** END CANCEL MODAL ***/


    render() {
        const tutorialSteps = [
            {
                target: '.timer',
                content: <div className="tutorial-modal-content"><h3>You have 3 days</h3><p>Modify your cart within this time with your skin advisors via text</p></div>,
                placement: 'bottom',
                disableBeacon: true,
            },
            {
                target: '.slick-arrow',
                content: <div className="tutorial-modal-content"><h3>You have more options</h3><p>Browse through your recommended products</p></div>,
                placement: 'top',
                disableBeacon: true,
            },
            {
                target: '.slick-slide',
                content: <div className="tutorial-modal-content"><h3>Learn more about each product</h3><p>If you want to know more about this product, simply click on it</p></div>,
                placement: 'bottom',
                disableBeacon: true,
            },
            {
                target: '.checkout-section',
                content: <div className="tutorial-modal-content"><h3>Confirm what you want</h3><p>Click here to confirm and purchase your new regimen</p></div>,
                placement: 'bottom',
                disableBeacon: true,
            }
        ];

        let name = localStorage.getItem('user_firstname');
        let CategoryHolder = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin: 30px 0 0.5em;
        position: relative
        `;

        let CategoryTitle = styled.div`
        height: 41px;
        line-height: 41px;
        background-color: rgba(252, 219, 207, 0.2);
        font-family: Montserrat;
        font-size: 1em;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-align: left;
        color: #272d67;
        padding: 0 5px;
        @media screen and (max-width: 414px) {
            font-size: 18px;
        }
        `;

        let CategorySmallTitle = styled.div`
        height: 41px;
        line-height: 41px;
        background-color: rgba(252, 219, 207, 0.2);
        font-family: Montserrat;
        font-size: 1em;
        font-weight: normal;
        font-style: italic;
        letter-spacing: 0.6px;
        text-align: left;
        color: #272d67;
        padding: 0 5px 0 0;
        @media screen and (max-width: 414px) {
            font-size: 18px;
        }
        `;

        let InformationButton = styled.div`
        font-size: 21px;
        color: #ffad94;
        margin-left: 2%;
        cursor: default;
        font-family: "Open Sans", Helevetica, Arial, sans-serif
        line-height: 15px;

        .info-popup {
            max-width: 414px;
            padding: 2.5% 3%;
            left: 0;
            z-index: 2;
            white-space: pre-line;
            visibility: hidden;
            background: #fff;
            position: absolute;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);


            p {
                font-size: 13px;
                color: #323232;

            }

            span {
                font-family: Montserrat, Helevetica, Arial, sans-serif;
                font-size: 14px;
                color: #262e66;
                font-weight: 600;
            }
        }

        &:hover .info-popup {
            visibility: visible;
        }
        `;

        const sliderSettings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            className: 'ha-slider-recommendations',
            responsive: [
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    className: 'ha-slider-recommendations'
                  }
                },
                {
                  breakpoint: 552,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    className: 'ha-slider-recommendations'
                  }
                }
              ]
        };


        //USED FOR RENDERING LABELS & INFO
        const indexMapProductsRef = {1:"Cleanser",2:"Toner",3:"Moisturizer",4:"SPF",5:"Serum",6:"Eye Cream",7:"Exfoliator",8:"Mask",11:"Make-Up Remover",12:"Treatment",15:"Supplement"};

        let productViews = [];
        let productViewsNone = [];
        const recommendedProducts = this.props.recommendedProducts;
        const numOfProducts = this.props.recommendedProducts ? recommendedProducts.length : 0;
        let tempIndex = -1;

        let selectedProductMap = {};

        recommendedProducts.sort((a, b) => {
            return indexMapProductsLabeled[a.type.toLowerCase()] - indexMapProductsLabeled[b.type.toLowerCase()];
        });

        recommendedProducts.forEach((product, index, arr) => {
            let productType = util.capitalize(product.type);
            let recommendedProductsCopy = recommendedProducts.filter((product,index,arr) => {
                    return util.capitalize(arr[index].type) === productType;
            });


            if (((index !== numOfProducts - 1) && (productType.toLowerCase() !== recommendedProducts[index+1].type.toLowerCase())) ||
                (index === numOfProducts - 1)
                ) {

                let productSliderContent = recommendedProductsCopy.map((product, index, arr) => {
                    return(
                        <div>
                            <Product
                                productCart={ this.state.productsCart }
                                isInProductCart={ this.state.productsCartIds.indexOf(product.id) > -1 }
                                product={product} index={ index } key={`product-${tempIndex}`}
                                defaultPurchaseOptIn={ this.state.defaultPurchaseStarted }
                                syncProducts={this.syncProducts}
                                selectProduct={ this.props.selectProduct }
                                selectReviewProduct={this.props.selectReviewProduct}
                                getProductsForCalcPrice={ this.getProductsForCalcPrice.bind(this) }
                                isFirstTime={ this.state.runTutorial }
                                saveCartForLater={ this.saveCartForLater }
                            />
                        </div>);
                });
                productViews.push(

                    <CategoryHolder className="category-name">
                        <CategoryTitle>{ productType }</CategoryTitle>
                        <CategorySmallTitle>for you</CategorySmallTitle>
                        <InformationButton>
                            &#9432;
                            <div className="info-popup">
                                <span>Why do you need this?</span>
                                <p>{
                                    regiment[productType.toLowerCase()]["whyNeed"] ? regiment[productType.toLowerCase()]["whyNeed"] : "No description available"
                                }</p>
                                <span>How to use it?</span>
                                <p>{
                                    regiment[productType.toLowerCase()]["howToUse"] ? regiment[productType.toLowerCase()]["howToUse"] : "No instructions available"
                                }</p>
                            </div>
                        </InformationButton>
                    </CategoryHolder>
                );
                productViews.push(
                    <Slider { ...sliderSettings } >
                        { productSliderContent }
                    </Slider>
                );
            }

            if (!(this.props.productTypes[0] === 13 || this.props.productTypes[0] === 14) && (index === numOfProducts - 1) && Object.keys(selectedProductMap).length > 0) {
                for (let key in selectedProductMap) {
                    productViews.push(
                        <CategoryHolder className="category-name">
                            <CategoryTitle>{ indexMapProductsRef[key] }</CategoryTitle>
                            <CategorySmallTitle>for you</CategorySmallTitle>
                            <InformationButton>
                                &#9432;
                                <div className="info-popup">
                                    <span>Why do you need this?</span>
                                    <p>{
                                        regiment[indexMapProductsRef[key].toLowerCase()]["whyNeed"] ? regiment[indexMapProductsRef[key].toLowerCase()]["whyNeed"] : "No description available"
                                    }</p>
                                    <span>How to use it?</span>
                                    <p>{
                                        regiment[indexMapProductsRef[key].toLowerCase()]["howToUse"] ? regiment[indexMapProductsRef[key].toLowerCase()]["howToUse"] : "No instructions available"
                                    }</p>
                                </div>
                            </InformationButton>
                        </CategoryHolder>
                    );
                    productViews.push(
                        <Slider { ...sliderSettings } >
                            <div>
                                <ProductNotFound />
                            </div>
                        </Slider>
                    );
                }
            }

        });

        if (this.props.recommendedProducts.length < 1 && this.props.productTypes.length > 0) {
            for (let key in selectedProductMap) {
                productViewsNone.push(
                    <CategoryHolder className="category-name">
                        <CategoryTitle>{ indexMapProductsRef[key] }</CategoryTitle>
                        <CategorySmallTitle>for you</CategorySmallTitle>
                        <InformationButton>
                            &#9432;
                            <div className="info-popup">
                                <span>Why do you need this?</span>
                                <p>{
                                    regiment[indexMapProductsRef[key]] && regiment[indexMapProductsRef[key].toLowerCase()]["whyNeed"] ? regiment[indexMapProductsRef[key].toLowerCase()]["whyNeed"] : "No description available"
                                }</p>
                                <span>How to use it?</span>
                                <p>{
                                    regiment[indexMapProductsRef[key]] && regiment[indexMapProductsRef[key].toLowerCase()]["howToUse"] ? regiment[indexMapProductsRef[key].toLowerCase()]["howToUse"] : "No instructions available"
                                }</p>
                            </div>
                        </InformationButton>
                    </CategoryHolder>
                );
                productViewsNone.push(
                    <Slider { ...sliderSettings } >
                        <div>
                            <ProductNotFound />
                        </div>
                    </Slider>
                );
            }
        }

        return(
            <div>
                <Responsive maxWidth={ 900 }>
                    <div className="timer-container-wrapper upper-section-wrapper">
                        {
                            this.state.defaultPurchaseStarted || this.state.defaultPurchaseComplete ?
                            <div className="timer-container" id="timer-container tutorial-step-1">
                                <div className="time-remaining">
                                    { !this.state.defaultPurchaseComplete ? "Time remaining:" : null }
                                </div>
                                <div className="timer">
                                    { this.state.defaultPurchaseComplete ? null : this.renderCountdownTimer() }
                                </div>
                            </div> : null
                        }
                    </div>
                </Responsive>
                <div className="tutorial">
                    <Tutorial
                        steps={ tutorialSteps }
                        run={ this.state.runTutorial }
                        callback={ this.tutorialCallback }
                        scrollToSteps={true}
                        debug={ false }
                        disableScrolling={ false }
                        continuous={ true }
                        styles={{
                            buttonNext: {
                                backgroundColor: '#ffad94',
                                color: '#fff',
                                borderRadius: '13.4px',
                                fontSize: '12px'
                            },
                            buttonBack: {
                                color: '#9b9b9b',
                                fontSize: '12px',
                                marginLeft: '0'
                            },
                            options: {
                                overlayColor: 'rgba(0, 0, 0, 0.2)'
                            }
                        }}
                        scrollToFirstStep={ true }
                    />
                </div>
                <div className="recommendations-bundle separate-view">
                    <div className="upper-section-wrapper">
                        <div className="upper-section">
                            <div className="your-plan">{ util.capitalize(name) }'s Regimen</div>
                            <Responsive minWidth={ 901 }>
                                {
                                    this.state.defaultPurchaseStarted || this.state.defaultPurchaseComplete ?
                                    <div className="timer-container" id="timer-container tutorial-step-1">
                                        <div className="time-remaining">
                                            { !this.state.defaultPurchaseComplete ? "Time remaining:" : null }
                                        </div>
                                        <div className="timer">
                                            { this.state.defaultPurchaseComplete ? null : this.renderCountdownTimer() }
                                        </div>
                                    </div> : null
                                }
                            </Responsive>
                        </div>
                    </div>
                    <div className="steps">
                        <div className="step step-one">
                        <div className="step-number">1</div>
                            <div className="title-content">
                                <div className="step-title">Personal skin advisor access</div>
                                <div className="step-content">
                                We are here to guide you pick the best products, answer any questions you have
                                related to your skin and help you adjust your regimen along your skincare journey.
                                </div>
                            </div>
                        </div>
                        <div className="step step-two">
                        <div className="step-number">2</div>
                            <div className="title-content">
                                <div className="step-title">
                                    { this.renderProductCategories() }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="products">
                        { this.props.recommendedProducts.length > 0 ? productViews : productViewsNone}
                    </div>
                    {
                        this.state.additionalRecommendedProducts && this.state.additionalRecommendedProducts.length > 0 ?

                        <div className="view-more-section">
                            <div className="view-more-title" onClick={ this.handleOpenAdditionalCategories } ><div className={ this.state.openAdditionalCategories ? "triangle rotate" : "triangle" }></div> What else is good for me?</div>
                            <div className={this.state.openAdditionalCategories ? "products show" : "products"}>
                                { this.renderAdditionalRecommendations() }
                            </div>
                        </div> :
                        null
                    }
                    <div style={!this.state.defaultPurchaseStarted ? {justifyContent: 'flex-end'} : null} className="refill-price-section">
                        {
                            this.state.defaultPurchaseStarted ?
                            <div className="cancel-shipment">
                                <a href="#/" onClick={ this.openCancelModal }>Cancel the shipment</a>
                            </div> :
                            null
                        }
                        <div className="price">
                            <div className="orig-price">
                                <div className="label">{ (this.props.userPaidGateFee && this.props.hasNeverPurchased) && (this.productsArr.length > 0 && this.props.amountPaidGateFee > 0) ? "Subtotal" : "Total" }: </div>
                                <div className={(this.props.userPaidGateFee && this.props.hasNeverPurchased) && (this.productsArr.length > 0 && this.props.amountPaidGateFee > 0) ? "total-price" : "total-price no-strikethrough"}>{ " $" + this.state.price }</div>
                            </div>
                            {(this.props.userPaidGateFee && this.props.hasNeverPurchased) && (this.productsArr.length > 0 && this.props.amountPaidGateFee > 0) ? <div className="you-save">
                                <div className="discount-offer">Consultation credit</div>
                                <div className="discount-amount">-${ this.props.amountPaidGateFee }</div>
                            </div> : null}
                            {(this.props.userPaidGateFee && this.props.hasNeverPurchased) && (this.productsArr.length > 0 && this.props.amountPaidGateFee > 0) ? <div className="discount-price">
                                <div className="label">Total</div>
                                <div className="total-price">{ "$" + parseFloat(this.state.price - this.props.amountPaidGateFee).toFixed(2) }</div>
                            </div> : null}
                        </div>
                    </div>
                </div>
                <Modal open={ this.state.openCancelModal } onClose={ this.closeCancelModal.bind(this) } /*little={ true }*/
                    classNames={{ overlay: 'ha-overlay cancel-overlay', modal: 'ha-modal cancel-confirm-modal', closeIcon: 'ha-modal-close' }}>
                        <img alt="cancel" src="/images/recommendations/cancel-icon.svg" />
                        <p>
                            Are you sure you want to cancel? You can still purchase at your own pace. The $10 skincare consultation fee will be credited towards your purchase.
                        </p>
                        <button onClick={ () => { this.setState({ openCancelModal: false }) } } >
                            Never mind. I will continue my purchase
                        </button>

                        <a href="#/" onClick={ this.handleOptOut } >
                            I would love to cancel this shipment
                        </a>

                </Modal>
            </div>
        );

    }

}


export default RecommendationsSeparateView;



// WEBPACK FOOTER //
// ./src/views/recommendations/RecommendationsSeparateView.js